import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useChapter } = getCRUDHooks({
  entityName: 'chapter',
  get: ({ courseId, chapterId }: { courseId: number; chapterId: string }) =>
    clientApi.getOCClient().helpers.learningContent.chapters.get(courseId, chapterId),
});

// eslint-disable-next-line import/prefer-default-export
export { useChapter };
